import React, { useEffect, useState, Fragment } from "react";
import ReactDOM from "react-dom";
import { fetchDevices } from "../Devices/Slice";
import { useAppDispatch } from "./store.hooks";
import { useSelector } from "react-redux";
import {
    loginSelector,
    loadingLoginSelector,
    errorLoginSelector,
} from "./Slice";

interface Props {
  children?: React.ReactNode;
}

const Layout = ({ children }: Props) => {

    const authResponse = useSelector(loginSelector);

    const [loggedIn, updateLoggedIn] = useState<boolean>(false);
    const dispatch = useAppDispatch();


    useEffect(() => {
        updateLoggedIn(authResponse);
    }, [authResponse]);
    useEffect(() => {
        if (loggedIn) {
            dispatch<any>(fetchDevices());
        }
  }, [loggedIn]);

  return <Fragment>{children}</Fragment>;
};
export default Layout;
